/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiResetPasswordForm,
    InternalApiResetPasswordFormFromJSON,
    InternalApiResetPasswordFormToJSON,
} from '../models';

export interface ResetPasswordRequest {
    internalApiResetPasswordForm: InternalApiResetPasswordForm;
}

/**
 * 
 */
export class UserForgotPasswordApi extends runtime.BaseAPI {

    /**
     * Resets password to a new one
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiResetPasswordForm === null || requestParameters.internalApiResetPasswordForm === undefined) {
            throw new runtime.RequiredError('internalApiResetPasswordForm','Required parameter requestParameters.internalApiResetPasswordForm was null or undefined when calling resetPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/users/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiResetPasswordFormToJSON(requestParameters.internalApiResetPasswordForm),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets password to a new one
     */
    async resetPassword(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit): Promise<void> {
        await this.resetPasswordRaw(requestParameters, initOverrides);
    }

}
